import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { FacilityDashboardComponent } from './facility-dashboard/facility-dashboard.component';
import { FacilityRuleComponent } from './facility-rule/facility-rule.component';
import { EventComponent } from './event/event.component';
import { EventsDashboardComponent } from './event/events-dashboard/events-dashboard.component';
import { EventBroadcastComponent } from './event/broadcast/event-broadcast.component';
import { GroupBookingBroadcastComponent } from './group-booking/broadcast/booking-broadcast.component';
import { GroupBookingComponent } from './group-booking/booking.component';
import { GroupBookingDashboardComponent } from './group-booking/booking-dashboard/booking-dashboard.component';
import { LinkComponent } from './link/link.component';
import { LinkDashboardComponent } from './link/link-dashboard/link-dashboard.component';
import { LinkBroadcastComponent } from './link/broadcast/link-broadcast.component';

const routes: Routes = [
    { path: 'facility', component: FacilityDashboardComponent, canActivate: [AuthGuard] },
    { path: 'addfacility', component: FacilityRuleComponent, canActivate: [AuthGuard] },
    { path: 'event-broadcast', component: EventBroadcastComponent, canActivate: [AuthGuard] },
    { path: 'events', component: EventsDashboardComponent, canActivate: [AuthGuard] },
    { path: 'addevent', component: EventComponent, canActivate: [AuthGuard] },
    { path: 'group-booking-broadcast', component: GroupBookingBroadcastComponent, canActivate: [AuthGuard] },
    { path: 'group-bookings', component: GroupBookingDashboardComponent, canActivate: [AuthGuard] },
    { path: 'add-group-booking', component: GroupBookingComponent, canActivate: [AuthGuard] },
    { path: 'addlink', component: LinkComponent, canActivate: [AuthGuard] },
    { path: 'links', component: LinkDashboardComponent, canActivate: [AuthGuard] },
    { path: 'link-broadcast', component: LinkBroadcastComponent, canActivate: [AuthGuard] },
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FacilityRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/facility/facility-routing.module.ts